import { render } from "./LimitedTheme.vue?vue&type=template&id=e8342420"
import script from "./LimitedTheme.vue?vue&type=script&lang=js"
export * from "./LimitedTheme.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__